module.exports = __webpack_public_path__ + "img/arrow-left.ac944051.svg";